import { IntegrationType } from 'types/model/merchant-settings';

export const MANUAL_MERCHANT_INTEGRATION_TYPE: IntegrationType = 'Manual';
